 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","AddressCreate":"AddressCreate","AddressEdit~Gig~Gigs~Gigsvenue~Joblist~Jobs":"AddressEdit~Gig~Gigs~Gigsvenue~Joblist~Jobs","AddressEdit":"AddressEdit","Gig~Gigs~Gigsvenue~Joblist~Jobs":"Gig~Gigs~Gigsvenue~Joblist~Jobs","Gig":"Gig","Gigs":"Gigs","Gigsvenue":"Gigsvenue","Joblist":"Joblist","Jobs":"Jobs","Addresscontacts":"Addresscontacts","Addresses":"Addresses","AddressesGeocode":"AddressesGeocode","Availabilities":"Availabilities","Contactof":"Contactof","Dashboard":"Dashboard","Festivaldata":"Festivaldata","Legal":"Legal","Login":"Login","Roster":"Roster","Stages":"Stages","Tours":"Tours","UserCreate":"UserCreate","UserDelete":"UserDelete","UserEdit":"UserEdit","UserList":"UserList"}[chunkId]||chunkId) + "." + {"404":"ce5e4107","AddressCreate":"45f9e331","AddressEdit~Gig~Gigs~Gigsvenue~Joblist~Jobs":"7bb8d250","AddressEdit":"4809e601","Gig~Gigs~Gigsvenue~Joblist~Jobs":"dca2ee32","Gig":"e7ca0005","Gigs":"99721dc9","Gigsvenue":"0e9e1cf4","Joblist":"7a20c174","Jobs":"9ba3e663","Addresscontacts":"6d734066","Addresses":"f2fdc467","AddressesGeocode":"7dcb0438","Availabilities":"bb07ee8a","Contactof":"e5709b0a","Dashboard":"21aadf62","Festivaldata":"b2b9d851","Legal":"e9a2c6b8","Login":"324aef4c","Roster":"7e493649","Stages":"92527ed1","Tours":"63b51f7d","UserCreate":"a4259c8d","UserDelete":"d374f0da","UserEdit":"79e7f65c","UserList":"b70ef6e7","chunk-2d0bacea":"37798ac3","chunk-2d0cbf31":"d38c5cb0","chunk-2d0f1157":"471827d2","chunk-2d2095cf":"3720d1c7","chunk-2d216412":"883d5414"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AddressEdit~Gig~Gigs~Gigsvenue~Joblist~Jobs":1,"Joblist":1,"AddressesGeocode":1,"Dashboard":1,"Roster":1,"UserList":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","AddressCreate":"AddressCreate","AddressEdit~Gig~Gigs~Gigsvenue~Joblist~Jobs":"AddressEdit~Gig~Gigs~Gigsvenue~Joblist~Jobs","AddressEdit":"AddressEdit","Gig~Gigs~Gigsvenue~Joblist~Jobs":"Gig~Gigs~Gigsvenue~Joblist~Jobs","Gig":"Gig","Gigs":"Gigs","Gigsvenue":"Gigsvenue","Joblist":"Joblist","Jobs":"Jobs","Addresscontacts":"Addresscontacts","Addresses":"Addresses","AddressesGeocode":"AddressesGeocode","Availabilities":"Availabilities","Contactof":"Contactof","Dashboard":"Dashboard","Festivaldata":"Festivaldata","Legal":"Legal","Login":"Login","Roster":"Roster","Stages":"Stages","Tours":"Tours","UserCreate":"UserCreate","UserDelete":"UserDelete","UserEdit":"UserEdit","UserList":"UserList"}[chunkId]||chunkId) + "." + {"404":"d41d8cd9","AddressCreate":"d41d8cd9","AddressEdit~Gig~Gigs~Gigsvenue~Joblist~Jobs":"1684b4a3","AddressEdit":"d41d8cd9","Gig~Gigs~Gigsvenue~Joblist~Jobs":"d41d8cd9","Gig":"d41d8cd9","Gigs":"d41d8cd9","Gigsvenue":"d41d8cd9","Joblist":"53329691","Jobs":"d41d8cd9","Addresscontacts":"d41d8cd9","Addresses":"d41d8cd9","AddressesGeocode":"1684b4a3","Availabilities":"d41d8cd9","Contactof":"d41d8cd9","Dashboard":"1af13f2d","Festivaldata":"d41d8cd9","Legal":"d41d8cd9","Login":"d41d8cd9","Roster":"f690e3da","Stages":"d41d8cd9","Tours":"d41d8cd9","UserCreate":"d41d8cd9","UserDelete":"d41d8cd9","UserEdit":"d41d8cd9","UserList":"0ef85729","chunk-2d0bacea":"d41d8cd9","chunk-2d0cbf31":"d41d8cd9","chunk-2d0f1157":"d41d8cd9","chunk-2d2095cf":"d41d8cd9","chunk-2d216412":"d41d8cd9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
